import styled from 'styled-components'
import type { FunctionComponent } from 'react'
import { Link } from 'react-router'
import AmsterdamLogo from '../../assets/icons/logo.svg'
import srOnlyStyle from '../../utils/srOnlyStyle'

const StyledLink = styled(Link)`
  height: 100%;
  width: auto;
  display: flex;
  align-items: center;
  margin-right: 1.5rem;
  color: black;
  text-decoration: none;
`

const StyledAmsterdamLogo = styled(AmsterdamLogo)`
  align-self: center;
  height: 40px;
  min-width: 8.75rem;
`

const Name = styled.div`
  font-size: 2.5rem;
  line-height: 1.1;
  font-weight: 800;
  width: 100%;
  margin-left: 6rem;
`

const ScreenReaderText = styled.div`
  ${srOnlyStyle};
`

interface AppLogoProps {
  displayTitle: boolean
  width: number
}

const AppLogo: FunctionComponent<AppLogoProps> = ({ displayTitle, width }) => (
  <StyledLink to="/" title="Logo Gemeente Amsterdam Data Amsterdam, naar home">
    <ScreenReaderText>Data verkenner</ScreenReaderText>
    <StyledAmsterdamLogo />
    {displayTitle && width >= 880 && <Name>Data&nbsp;Amsterdam</Name>}
  </StyledLink>
)

export default AppLogo
